import { REGION_ENVIRONMENT } from 'SharedDir/constants/common';
import { FeatureFlagName, RegionEnv } from 'SharedDir/declarations/system/region-customization';

/**
 * Представляет собой объект, который связывает регионы с набором флагов функциональности.
 * Каждый регион, представленный в виде ключа RegionEnv, имеет соответствующий массив флагов FeatureFlagName,
 * которые определяют, какие функции или элементы интерфейса должны быть видимы или активны региона
 */
export const featureFlags: Record<RegionEnv, Array<FeatureFlagName>> = {
  [RegionEnv.HMAO]: [
    FeatureFlagName.IsVisibleServiceKindId,
    FeatureFlagName.IsVisibleServiceSegments,
    FeatureFlagName.IsVisibleStatisticsInPortal,
    FeatureFlagName.IsVisibleFeedbackBtnInPortal,
    FeatureFlagName.IsVisiblePatternInModalPortal,
    FeatureFlagName.IsVisibleUgraIdInAdmin,
    FeatureFlagName.IsVisibleExcerptTtp,
    FeatureFlagName.IsVisibleExcerptOrganization,
    FeatureFlagName.IsVisibleIntegrationExcerpt,
    FeatureFlagName.IsVisibleLinksToEthnoportalInPortal,
    FeatureFlagName.IsInitialIntegrationAvailable,
    FeatureFlagName.isVisibleChannelsExplainKmns,
    FeatureFlagName.IsInRussianSoftwareRegistry,
    FeatureFlagName.HasTtpRegistry,
    FeatureFlagName.HasThdRegistry,
    FeatureFlagName.SupportsDirectumLikeDocuments,
    FeatureFlagName.SupportsCommissions,
    FeatureFlagName.HasIntegrationActualizations,
    FeatureFlagName.HasRmsStatistics,
  ],
  [RegionEnv.YANAO]: [
    FeatureFlagName.IndividualDeer,
    FeatureFlagName.IsInitialIntegrationAvailable,
    FeatureFlagName.IsVisiblePersonNomadic,
    FeatureFlagName.HasTMCRegistry,
    FeatureFlagName.HasBankAgreements,
    FeatureFlagName.HasIntegrationActualizations,
    FeatureFlagName.HasDepzdravPersonExport,
    FeatureFlagName.HasNSUDRegistry,
    FeatureFlagName.PhysicalPersonCustomWay,
    FeatureFlagName.SupportsZagsEGISSOIntegration,
    FeatureFlagName.SupportsLowIncomeIntegration,
    FeatureFlagName.SupportsSvoCategory,
    FeatureFlagName.HasLegacyDocuments,
    FeatureFlagName.HasBankAccount,
    FeatureFlagName.SupportsYanaoReports,
    FeatureFlagName.HasMyCertificates,
    FeatureFlagName.HasBanks,
    FeatureFlagName.HasAuthorizedOrgans,
    FeatureFlagName.HasTojRegistry,
    FeatureFlagName.HasIssueDocuments,
    FeatureFlagName.HasUserActivityStatistics,
    FeatureFlagName.HasUserActions,
    FeatureFlagName.HasReportFormTemplateImport,
    // FeatureFlagName.HasReportFormConsolidation,
    FeatureFlagName.HasReportFormSignature,
    FeatureFlagName.HasReportFormPdfXml,
    FeatureFlagName.HasReportFormAttachment,
  ],
};

export class FeatureFlagsService {
  /**
   * Определяет текущий регион из переменной REGION_ENVIRONMENT.
   * Проверяет, существует ли конфигурация фиче-флагов для текущего региона.
   * Возвращает true, если указанный фиче-флаг активен в текущем регионе, иначе false.
   * Выводит предупреждение в консоль, если фиче-флаг отсутствует в конфигурации.
   *
   * @param featureName
   * @returns
   */
  static isFeatureEnabled(featureName: FeatureFlagName): boolean {
    const currentRegion = REGION_ENVIRONMENT as RegionEnv;

    if (!(currentRegion in featureFlags)) {
      // Если для текущего региона нет настроек фиче-флагов
      console.warn(`Фиче-флаг ${featureName} отсутствует в конфигурации`);
      return false;
    }

    const featuresForRegion = featureFlags[currentRegion];

    return featuresForRegion.includes(featureName);
  }
}
